/**
 * Shared UI strings used across step pages and share flows.
 * Values resolve through the i18n catalog (active locale → fallback → en).
 */

import { t } from '../i18n/translate';

export const STEP_UI = {
  get READ_GREEN_BOOK() {
    return t('ui.READ_GREEN_BOOK');
  },
  get READ_GUIDANCE() {
    return t('ui.READ_GUIDANCE');
  },
  get WATCH_VIDEO() {
    return t('ui.WATCH_VIDEO');
  },
  get SHARE_WITH_SPONSOR() {
    return t('ui.SHARE_WITH_SPONSOR');
  },
  get FIRST_STEP_WRITING_WORKSPACE() {
    return t('ui.FIRST_STEP_WRITING_WORKSPACE');
  },
  get OPEN_AMENDS_LIST() {
    return t('ui.OPEN_AMENDS_LIST');
  },
  get PRACTICE_INVENTORY() {
    return t('ui.PRACTICE_INVENTORY');
  },
  get ENTER_UPDATE_3_CIRCLES() {
    return t('ui.ENTER_UPDATE_3_CIRCLES');
  },
  get COMPLETED() {
    return t('ui.COMPLETED');
  },
  get EXPAND() {
    return t('ui.EXPAND');
  },
  get COLLAPSE() {
    return t('ui.COLLAPSE');
  },
};

export const SHARE_ACTION_TITLE_KEY = 'ui.SHARE_ACTION_TITLE';
export const SHARE_DEFECTS_ACTION_TITLE_KEY = 'ui.SHARE_DEFECTS_ACTION_TITLE';

export function getShareActionTitle(): string {
  return t(SHARE_ACTION_TITLE_KEY);
}

export function getShareDefectsActionTitle(): string {
  return t(SHARE_DEFECTS_ACTION_TITLE_KEY);
}

export function getDefaultShareEmptyMessage(): string {
  return t('ui.DEFAULT_SHARE_EMPTY_MESSAGE');
}

/** Legacy aliases — prefer getShareActionTitle() / getShareDefectsActionTitle(). */
export const SHARE_ACTION_TITLE = SHARE_ACTION_TITLE_KEY;
export const SHARE_DEFECTS_ACTION_TITLE = SHARE_DEFECTS_ACTION_TITLE_KEY;
export const DEFAULT_SHARE_EMPTY_MESSAGE = 'ui.DEFAULT_SHARE_EMPTY_MESSAGE';
